export default "__VITE_ASSET__zrzHjsdN__"